export enum VisibilityState {
  Hide = 'hide',
  Show = 'show',
}

export enum Position {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top',
}

export const DEFAULT_MIN_ZOOM = 0.08;
export const DEFAULT_MAX_ZOOM = 10;
export const DEFAULT_PADDING = 50;
export const globalKey = 'itblGlobal';
